/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_SubtitleInputs */



/**
* | output |
* | --- |
* | "Start your free trial today" |
*
* @param {Signup_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_subtitle = /** @type {((inputs?: Signup_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencez votre essai gratuit aujourd'hui")
	if (locale === "de") return /** @type {LocalizedString} */ ("Starten Sie noch heute Ihre kostenlose Testphase.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia oggi la tua prova gratuita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начните бесплатную пробную версию сегодня!")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comience su prueba gratuita hoy")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("立即开始免费试用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("今すぐ無料トライアルを始めましょう")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना मुफ्त ट्रायल आज ही शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comece seu teste gratuito hoje mesmo")
	return /** @type {LocalizedString} */ ("Start your free trial today")
});